<template>
  <footer class="portal-footer">
    <div class="portal-footer__inner">
      <router-link :to="{ name: 'HomePage' }" class="portal-brand portal-brand--footer" aria-label="UCARI home">
        <img src="/images/ucari-logo-white-v3.png" alt="UCARI" />
        <span>Partner Portal</span>
      </router-link>
      <nav aria-label="Footer">
        <router-link :to="{ name: 'RetailTerms' }">Retail terms</router-link>
        <a href="https://www.ucari.com/privacy" target="_blank" rel="noopener">Privacy</a>
        <a href="mailto:care@ucari.com">Support</a>
      </nav>
      <p>&copy; {{ currentYear }} UCARI. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'RetailerFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
